import { map, distinctUntilChanged, take } from 'rxjs/operators'
import { BehaviorSubject, 
         ReplaySubject} from 'rxjs'

import { Injectable } from '@angular/core'

// import { AppStatic } from '../_helpers/app-static'
import { CookieConsent } from '../_models/cookie-consent.model'

// import { CookieService as NgxCookieService } from 'ngx-cookie-service'
// import { CookieService as NgxCookieService } from 'ngx-cookie-service'
import { LocalStorageService,
         SessionStorageService } from 'ngx-webstorage'



@Injectable()
export class CookieService {

  // private cookieConsentSubject = new BehaviorSubject<CookieConsent>(null)
  private cookieConsentSubject = new ReplaySubject<CookieConsent>(1) // <CookieConsent>(null)
  public cookieConsent = this.cookieConsentSubject.asObservable().pipe(distinctUntilChanged())
  private cookieConsentLocal: CookieConsent = new CookieConsent()

  private requireCookieConsentSubject = new BehaviorSubject<boolean>(true)
  public requireCookieConsent = this.requireCookieConsentSubject.asObservable().pipe(distinctUntilChanged())
  private requireCookieConsentLocal = true

  constructor(
    // private ngxCookieService: NgxCookieService
    private localStorageService: LocalStorageService,
    private sessionStorageService: SessionStorageService
  ) { }

  populateCookieConsentFromCookie() {
    let currentCookie = this.getCookieConsent()
    if (!currentCookie) return
    this.updateCookieConsent(currentCookie)
  }

  getCookieConsent(): CookieConsent {
    let fromWindow = this.get('local', 'lcp_cookie_consent')
    // if (!fromWindow) { console.log('!getCookin'); return }
    let parsedJSON = JSON.parse(fromWindow)
    let cookieConsent = new CookieConsent(parsedJSON)
    return cookieConsent
  }

  setCookieConsent(cookieConsent: CookieConsent) {
    let stringified = cookieConsent && JSON.stringify(cookieConsent)
    this.set('local',  'lcp_cookie_consent', stringified, { force: true })
    // this.setCookie('lcp_cookie_consent', JSON.stringify(cookieConsent), { force: true })
    this.updateCookieConsent(cookieConsent)
  }

  private updateCookieConsent(cookieConsent: CookieConsent) {
    let cc = new CookieConsent(cookieConsent)
    this.cookieConsentLocal = cc
    this.cookieConsentSubject.next(cookieConsent)
  }

  updateRequireCookieConsent(requireCookieConsent: boolean) {
    this.requireCookieConsentLocal = requireCookieConsent
    this.requireCookieConsentSubject.next(requireCookieConsent)
  }

  removeCookieConsent() {
    this.set('local', 'lcp_cookie_consent', null)
    // this.setCookie('lcp_cookie_consent', null)
    // let nullCookieConsent = new CookieConsent()
    this.setCookieConsent(null)
  }

  setCookie(cookie: string, value: string, paramsIn = {} ): (boolean|void) {
    let cc = this.getCookieConsent()
    if (!paramsIn['force'] && !cc) return console.log('!cc!', cc)
    delete paramsIn['force']

    console.log('STORING', cookie)
    // if (this.ngxCookieService.get(cookie)) return false // { console.log('already set...'); return false }
    // this.ngxCookieService.set(cookie, value, 365, '/', null, null, null)
    this.localStorageService.store(cookie, value)
    return true
  }

  log(storage: string, key: string) {
    let logStr = key ? this.get(storage, key) : 'NULL!'
    // console.log('cookie.log', storage, key, logStr)
  }

  set(storage: string, key: string, value: any, params  =  {}) {
    // console.log('TODO: check cookie-consent')
    // if (!params['force'] && !this.getCookieConsent()) return console.warn('ERR: cookie consent?')

    switch (storage) {
      case 'local': return this.localStorageService.store(key, value)
      case 'session': return this.sessionStorageService.store(key, value)
      default: console.log('cookieService set: bad key', storage)
    }
  }

  get(storage: string, key: string) {
    // console.log('this.localStorageService.retrieve(key)', res)

    switch (storage) {
      case 'local': {
        let res
        try {
          // console.log('GETTING-COOKIE', storage, key)
          res = this.localStorageService.retrieve(key)
          // console.log('GOT-COOKIE', res)
          return res
        } catch(error) {
          // console.log('ERR', error)
          return error
        }
      }
      // return this.localStorageService.retrieve(key)
      case 'session': return this.sessionStorageService.retrieve(key)
      default: console.log('cookieService get: bad key', storage)
    }
  }

  delete(storage: string, key: string) {
    switch (storage) {
      case 'local': return this.localStorageService.clear(key)
      case 'session': return this.sessionStorageService.clear(key)
      default: console.log('cookieService delete: bad key', storage)
    }
  }

  observe(storage: string, key: string) {
    switch (storage) {
      case 'local': return this.localStorageService.observe(key)
      case 'session': return this.sessionStorageService.observe(key)
      default: console.log('cookieService observe: bad key', storage)
    }
  }
}
